export const MAX_PLAYS_COUNT = 999_999_999;

export const normalizePlaysCount = (value) => {
  if (value === null || value === undefined || value === '') {
    return null;
  }

  let count;
  if (typeof value === 'number') {
    count = value;
  } else if (typeof value === 'string') {
    const trimmedValue = value.trim();
    if (!/^\d+$/.test(trimmedValue)) {
      return null;
    }
    count = Number(trimmedValue);
  } else {
    return null;
  }

  return Number.isSafeInteger(count) && count >= 0 && count <= MAX_PLAYS_COUNT
    ? count
    : null;
};
